export const isIE = () => navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
export const isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;

export const isAndroid = () => navigator.userAgent.toLowerCase().indexOf('android') !== -1;
export const isAppleDevice = () => /ipad|iphone|ipod/.test(navigator.userAgent.toLowerCase());
